import { useEffect, useState } from 'react';
import SubmitApplications from 'components/global/SubmitApplications';
import { checkEdoPermissionsAcrossPrograms } from '../../../../libs/edoPermissions';
import userAccountSignal from '../../../../signals/UserAccount.signal';
import api from '../../../../api/api';
import loaderSignal from '../../../../signals/Loader.signal';

const EdoSubmitApplications = () => {
  const [canInsert, setCanInsert] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkInsertPermission = async () => {
      try {
        setIsChecking(true);
        loaderSignal.update({ isContentLoading: true });
        const userData = userAccountSignal.value.userData;
        
        // Wait for userData to be loaded
        if (!userData) {
          setIsChecking(false);
          loaderSignal.reset();
          return;
        }

        // Fetch funding programs for the EDO
        const fundingPrograms = await api.get({
          path: '/fundingPrograms',
          options: {
            where: {
              edoId: userData?.account.edoId,
            },
          },
        });

        const permissions = await checkEdoPermissionsAcrossPrograms(
          fundingPrograms,
          ['canInsert']
        );
        setCanInsert(permissions.canInsert);
      } catch (error) {
        console.error('Error checking insert permission:', error);
        setCanInsert(false);
      } finally {
        setIsChecking(false);
        loaderSignal.reset();
      }
    };

    checkInsertPermission();
  }, [userAccountSignal.value.userData]);

  if (isChecking) {
    return null; // Or show a loading spinner
  }

  if (!canInsert) {
    return (
      <div className="bg-white p-32 border border-gray shadow-sm">
        <h3 className="text-center">Access Denied</h3>
        <p className="text-center">
          You do not have permission to create applications.
        </p>
      </div>
    );
  }

  return <SubmitApplications />;
};

export default EdoSubmitApplications;
